module.exports = __webpack_public_path__ + "img/basilur-small.04b8d62f.svg";